import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import format from "date-fns/format";
import { useDispatch, useSelector } from "react-redux";
import { pascalCase } from "pascal-case";
import { userSelector } from "../../redux/authSlice";
import { addNewLookup, lookupSelector } from "../../redux/lookupSlice";

import { resetInspection } from "../../redux/inspectionSlice";
import SurveyForm from "./SurveyForm";

import {
  isUpdatedSelector,
  onDismiss,
  onUpdate,
  resetSurvey,
  submitSurvey,
  surveySelector,
} from "../../redux/surveySlice";
import { Icon } from "@iconify/react";
import { error } from "../../redux/notificationSlice";
import InspectionModal from "./InspectionModal";
import NoSurvey from "../../pages/NoSurvey";
import InspectionList from "./InspectionList";

const InspectionDetail = () => {
  const [modalShow, setModalShow] = useState(false);
  const [index, setIndex] = useState(-1);
  const onHide = () => {
    setModalShow(false);
    dispatch(resetInspection());
  };
  const survey = useSelector(surveySelector);
  const isUpdated = useSelector(isUpdatedSelector);
  const lookup = useSelector(lookupSelector);
  const user = useSelector(userSelector);
  const dispatch = useDispatch();

  const surveySubmit = () => {
    if (survey.noOfSpacesPitchesBedSpaces < 0) {
      dispatch(
        error("Number of spaces/pitches/bed spaces can't be less than zero")
      );
      return;
    }
    checkLookups("tenure");
    checkLookups("locality");
    dispatch(submitSurvey({ survey, user }));
  };

  const checkLookups = (key) => {
    if (
      survey[key] &&
      lookup[key]?.findIndex((look) => look.id === survey[key]) === -1
    ) {
      dispatch(addNewLookup({ key, value: survey[key] }));
    }
  };

  const onResetHandle = () => {
    if (isUpdated) {
      const isConfirmed = window.confirm(
        "Your changes are not saved yet. Are you sure you want to go back?"
      );
      if (isConfirmed) {
        dispatch(resetSurvey());
        dispatch(onDismiss());
      }
    } else {
      dispatch(resetSurvey());
    }
  };

  return (
    <>
      <div className={`inspectionDetail ${survey.id ? "active" : ""}`}>
        {!survey.id ? (
          <NoSurvey
            type="No survey selected"
            text="No survey selected. Please select one to submit."
          />
        ) : (
          <>
          <div className="mainDetailWrapper">
            <div className="cardHeader">
              <div className="headerMobile d-flex d-lg-none">
                <span className=" backArrow">
                  <Icon
                    onClick={() => onResetHandle()}
                    icon="eva:arrow-ios-back-outline"
                  />
                </span>
                <p>{survey.address}</p>
              </div>
              <div className="caption">
                <div className="cBody">
                  <h3>{survey.hdcAssetReference}</h3>
                  <h4>{pascalCase(survey?.status || "draft")}</h4>
                  <p>{survey.address}</p>
                </div>
                <div className="action">
                  <Link to="#" className="cta">
                    {pascalCase(survey?.status || "draft")}
                  </Link>
                  <Link
                    to="#"
                    className="btn cta-primary"
                    onClick={() => surveySubmit()}
                  >
                    Post
                  </Link>
                </div>
              </div>
              <hr />
              <Row>
                <Col>
                  <div className="card_text">
                    <h5>WHE Ref</h5>
                    <p>{survey.wheRef}</p>
                  </div>
                </Col>
                <Col>
                  <div className="card_text">
                    <h5>Client Ref</h5>
                    <p>{survey.clientRef}</p>
                  </div>
                </Col>
                <Col>
                  <div className="card_text">
                    <h5>Address</h5>
                    <p>{survey.address}</p>
                  </div>
                </Col>
                <Col>
                  <div className="card_text">
                    <h5>Date Assigned</h5>
                    <p>
                      {survey?.modifiedOn &&
                        format(new Date(survey?.modifiedOn), "dd/MM/yyyy")}
                    </p>
                  </div>
                </Col>
                <Col>
                  <h5>Inspector</h5>
                  <p>
                    {user?.firstName} {user?.lastName}
                  </p>
                </Col>
              </Row>
            </div>
            <div className="cardBody">
              <Row className="align-items-center">
                <SurveyForm />
              </Row>
              <div className="d-lg-none d-block inspectionMobile">
            {survey.id && <InspectionList showAdd={true} />}
            </div>
            </div>
           
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default InspectionDetail;
